import React from "react";

interface DashboardCardProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  /** Lets a data table card hand its own height to the grid. */
  bodyClassName?: string;
  /** Grid placement from the parent, e.g. spanning both columns. */
  className?: string;
}

export const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  description,
  action,
  children,
  bodyClassName = "",
  className = "",
}) => (
  <section
    className={`flex min-w-0 flex-col rounded-xl border border-od-border bg-od-surface ${className}`}
  >
    <header className="flex items-start gap-3 border-b border-od-border px-4 py-3">
      <div className="min-w-0 flex-1">
        <div className={action ? "flex min-h-11 items-center sm:min-h-8" : undefined}>
          <h2 className="m-0 break-words text-sm font-semibold text-od-text">
            {title}
          </h2>
        </div>
        {description && (
          <p className="m-0 mt-0.5 break-words text-xs text-od-muted">
            {description}
          </p>
        )}
      </div>
      {action}
    </header>
    <div className={`min-w-0 ${bodyClassName || "p-4"}`}>{children}</div>
  </section>
);

export default DashboardCard;
